import React, { Fragment, useEffect, useState } from "react";
import '../css/bootstrap.min.css'
import './css/circliful.css'
import './css/font.css'
import '../css/devoloper2.css'
import NavLogo from '../assets/logo.jpg'
import { Link, useParams } from 'react-router-dom'
import NavLogo1 from '../images/giaa.png'
import { Grid } from "@nextui-org/react";
import { adminPermission, association } from "../apis/urls";
import axios from "axios";

const SideNavbar = () => {
  const [arr, setArr] = useState('')
  let urole = localStorage.getItem('userrole');
  let schools = localStorage.getItem('schoolid')
  let associationid = localStorage.getItem('association');
  const [loader, setLoader] = useState(false);
  const [result, setResult] = useState([]);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    if (associationid || urole === "ASSOCIATION_USER") {
      let arrs = associationid.split(',');
      AssociationView(arrs);
    }
  }, []);

  useEffect(() => {
    document.body.classList.remove('new-login-wrpr');
    setLoader(true);
    const token = "Bearer " + localStorage.getItem('token');
    const instance = axios.create({
      baseURL: adminPermission + "/getpermission",
      timeout: 1000000,
      headers: { 'authorization': token },
    });
    instance.get("").then((response) => {
      setResult(response.data.users || []);
      setPermissions(response.data.permissions || {});
      setLoader(false);
    }).catch((error) => {
      setLoader(false);
    });
  }, []);

  const AssociationView = (ids) => {

    let token = "Bearer "+localStorage.getItem('token');

    const data = {
        ids: ids
    }

    const instance = axios.create({
        baseURL: association+"multiple",
        timeout: 1000000,
        headers: {'authorization': token}
      });

      instance.get('', data).then(async res => {
        setArr(res.data?.data)
        console.log(res.data?.data[0])
    });
}


  let token = localStorage.getItem('token');
  let official_id = localStorage.getItem('official');
  let coachId = localStorage.getItem('coachid');
 //console.log('usee role',urole)
   

  //SVGComponentTransferFunctionElement.log()
  


    return ( 
      
        <div className="wrapper">
          {
            
            
            urole === 'HO_SCHOOL' ?
            (
              token?
               
             
              (<aside className="left-side side-off-canvas showcolor">
              
              
              
                <div className="logo-wrpr">
                      <img src={NavLogo} width="" height="" alt="" />
                </div>
              <div className="navbar  sidenavbar">
                    <ul className="nav">
                        {/* <li><Link className="sidenav-link" to="/dashboard"><i className="icon-dashboard1"></i> Dashboard</Link></li> */}
                        <li><Link  to={"/school_list/faculty/"+schools} ><i className="icon-stack3"></i> Faculty</Link></li>
                        <li><Link  to={"/members/"+schools} ><i class="icon-message"></i>Permissions</Link></li>
                        <li><Link  to={"/jobs/"+schools}><i className="sidenav-link faculty icon-suitcase1"></i> Jobs</Link></li>
                        <li><Link  to={"/school_list/athlet_list/"+schools}><i className="icon-group_work"></i>Athletic Eligibility</Link></li>
                        <li><Link  to={"/school_profile/"+schools} ><i  className="sidenav-link view icon-eye"></i> Profile</Link></li>
                        <li><Link  to={"/edit_school/"+schools}><i  class="edit icon-pencil3"></i>Update School</Link></li>
                        
                        <li><Link  to="/links"><i class="edit icon-link2"></i>Links</Link></li>
                        {/* <li><Link  to="/rules"><i className="icon-clipboard1"></i> Rules</Link></li> */}
                    </ul>
                  </div>


              </aside>):
              (<aside className="left-side side-off-canvas nocolor">

                <div className="logo-wrpr">
                        <img src={NavLogo} width="" height="" alt="" />
                  </div>

              </aside>)
              
            ) :


            urole === 'ATHLETIC_MANAGER' ?

            (
              
                token?
                (<aside className="left-side side-off-canvas showcolor">
                    <div className="logo-wrpr">
                          <img src={NavLogo} width="" height="" alt="" />
                    </div>
                

                  <div className="navbar  sidenavbar">
                    <ul className="nav"> 

                    {/* <li><Link className="sidenav-link" to="/dashboard"><i className="icon-dashboard1"></i> Dashboard</Link></li> */}
                        <li><Link  to={"/school_list/faculty/"+schools} ><i className="icon-stack3"></i> Faculty</Link></li>
                       
                        <li><Link  to={"/jobs/"+schools}><i className="sidenav-link faculty icon-suitcase1"></i> Jobs</Link></li>
                   
                        <li><Link  to={"/school_list/athlet_list/"+schools}><i className="icon-group_work"></i>Athletic Eligibility</Link></li>
                        <li><Link  to={"/school_profile/"+schools} ><i  className="sidenav-link view icon-eye"></i> Profile</Link></li>
                        <li><Link  to={"/edit_school/"+schools}><i  class="edit icon-pencil3"></i>Update School</Link></li>
                       
                        <li><Link  to="/links"><i  class="edit icon-link2"></i>Links</Link></li>
                        {/* <li><Link  to="/rules"><i className="icon-clipboard1"></i> Rules</Link></li> */}
                    </ul>
                  </div>


              </aside>):

              (<aside className="left-side side-off-canvas nocolor">

              <div className="logo-wrpr">
                      <img src={NavLogo} width="" height="" alt="" />
                </div>

              </aside>)
             
            ):

            urole === 'ASSOCIATION_USER' ?

            (
              token?
              (<aside className="left-side side-off-canvas showcolor">
                <div className="logo-wrpr">
                      <img src={NavLogo1} style={{width:'80px'}} width="" height="" alt="" />
                </div>  

                <div className="navbar  sidenavbar">
                      
                    <ul className="nav">
                          {arr?.length === 1?
                          <>
                          <li><Link  to={"/associationview/"+arr[0].id} ><i className="view icon-eye"></i>Profile </Link></li>
                          <li><Link  to={"/association_officials/"+arr[0].id} ><i className="icon-baseball"></i>Officials </Link></li>
                          </>:
                          <li><Link  to={"/select_association"} ><i className="view icon-eye"></i>Select Association</Link></li>
                          }
                      </ul>

                    </div>
            

              </aside>):
              (<aside className="left-side side-off-canvas nocolor">

              <div className="logo-wrpr">
                      <img src={NavLogo} width="" height="" alt="" />
                </div>

              </aside>)

            ):

            urole === 'OFFICIALS_USER'?

            (
              token?
              (<aside className="left-side side-off-canvas showcolor">
                <div className="logo-wrpr">
                      <img src={NavLogo} width="" height="" alt="" />
                </div>  

                <div className="navbar  sidenavbar">
                      
                    <ul className="nav">
                          
                    <li><Link className="sidenav-link" to={"/select_rule/"}><i className="icon-dashboard1"></i> Dashboard</Link></li>
                        
                      </ul>

                    </div>
                

              </aside>):
              (<aside className="left-side side-off-canvas nocolor">

              <div className="logo-wrpr">
                      <img src={NavLogo} width="" height="" alt="" />
                </div>

              </aside>)

            ):

              
              
            (
              token?
            
            (<aside className="left-side side-off-canvas showcolor">
              <div className="logo-wrpr">
                      <img src={NavLogo} width="" height="" alt="" />
              </div>
              
                  
                    <div className="navbar  sidenavbar">
                        <ul className="nav">

                            {permissions.dashboard === 1 && (
                              <li><Link className="sidenav-link" to="/dashboard"><i className="icon-dashboard1"></i> Dashboard</Link></li>
                            )}
                           
                            {permissions.schools === 1 && (
                              <li><Link className="sidenav-link nav__link" to="/school_list"><i className="icon-stack3"></i>Schools</Link></li>
                            )}
                            {permissions.officials === 1 && (
                              <li><Link className="sidenav-link" to="/associations"><i className="icon-group_work"></i> Officials</Link></li>
                            )}
                            {permissions.rules === 1 && (
                              <li><Link to="/rules"><i className="icon-clipboard1"></i> Rules</Link></li>
                            )}
                            {/* Events dropdown */}
                            {permissions.seminar === 1 || permissions.conference_manager === 1 || permissions.exhibitor === 1 ? (
                              <div className="nav__dropdown">
                                <li>
                                  <a className="sidenav-link nav__link">
                                    <div style={{ width: '100px' }}>
                                      <i className="icon-event_note"></i>
                                      Events
                                    </div>
                                    <i className="icon-keyboard_arrow_right right-arrow" style={{ background: 'transparent', color: '#fff' }}></i>
                                  </a>
                                </li>
                                <div className="nav__dropdown-collapse">
                                  {permissions.seminar === 1 && (
                                    <li><Link className="dropdown-item" to="/conference">Seminar</Link></li>
                                  )}
                                  {permissions.conference_manager === 1 && (
                                    <li><Link className="dropdown-item" to="/workshop">Conference Manager</Link></li>
                                  )}
                                  {permissions.exhibitor === 1 && (
                                    <li><Link className="dropdown-item" to="/exhibition">Exhibitor</Link></li>
                                  )}
                                </div>
                              </div>
                            ) : null}
                            {/* Masters dropdown */}
                            {permissions.master === 1 && (
                              <div className="nav__dropdown">
                                <li><a className="sidenav-link nav__link"><i className="icon-stack3"></i> Masters<i className="icon-keyboard_arrow_right right-arrow"></i></a></li>
                                <div className="nav__dropdown-collapse">
                                  <li><Link className="dropdown-item" to="/accreditation">Accreditation</Link></li>
                                  <li><Link className="dropdown-item" to="/county_list">County</Link></li>
                                  <li><Link className="dropdown-item" to="/degreelist">Degree</Link></li>
                                  <li><Link className="dropdown-item" to="/facultycategory">Faculty Category</Link></li>
                                  <li><Link className="dropdown-item" to="/facultyposlist">Faculty Positions</Link></li>
                                  <li><Link className="dropdown-item" to="/gisapprovelist">Foreign Exchange</Link></li>
                                  <li><Link className="dropdown-item" to="/jobcategorylist">Job Categories</Link></li>
                                  <li><Link className="dropdown-item" to="/links">Links</Link></li>
                                  <li><Link className="dropdown-item" to="/region_list">Region</Link></li>
                                  <li><Link className="dropdown-item" to="/sportslist">Sports</Link></li>
                                  <li><Link className="dropdown-item" to="/tablecostlist">Table Cost</Link></li>
                                  <li><Link className="dropdown-item" to="/elecostlist">Electricity Cost</Link></li>
                                </div>
                              </div>
                            )}
                             {permissions.admin === 1 && (
                            <li><Link className="sidenav-link" to="/admins"><i className="icon-user"></i> Admins</Link></li>
                            )}
                        </ul>
                    </div>
                  
          </aside>):

          (<aside className="left-side side-off-canvas nocolor">

          <div className="logo-wrpr">
                <img src={NavLogo} width="" height="" alt="" />
          </div>

          </aside>)
          
          )
            
          }
            


            
    </div>     
            )
};

export default SideNavbar;
